import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    groupName: String,
    parentId: String,
    triggerOptionId: String
  }
  static targets = ["position"]

  connect() {
    new Sortable(this.element, {
      animation: 150,
      swapThreshold: 0.65,
      handle: ".sortable-position__draggable-handler",
      ghostClass: "sortable-position__draggable-ghost",
      draggable: ".sortable-position__draggable-item",
      group: this.groupNameValue,
      onMove: (event) => !event.dragged.contains(event.to),
      onEnd: (event) => this.persistPosition(event)
    })
  }

  persistPosition(event) {
    const url = event.item.dataset.sortablePositionUrl
    if (!url) return

    const body = { position: event.newDraggableIndex + 1 }
    const destination = event.to.dataset
    if ("sortablePositionParentIdValue" in destination) {
      body.parent_id = destination.sortablePositionParentIdValue
      body.trigger_choice_list_option_id = destination.sortablePositionTriggerOptionIdValue
      if (event.to !== event.from) {
        this.rewriteSiblingInsertLinks(event.item, body.parent_id, body.trigger_choice_list_option_id)
      }
    }

    fetch(url, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }).then((response) => {
      if (!response.ok) window.location.reload()
    })
  }

  rewriteSiblingInsertLinks(item, parentId, triggerOptionId) {
    item.querySelectorAll(":scope > .dropdown a[href]").forEach((link) => {
      const url = new URL(link.href)
      url.searchParams.set("parent_id", parentId)
      url.searchParams.set("trigger_choice_list_option_id", triggerOptionId)
      link.href = url.toString()
    })
  }
}
